module.exports = __webpack_public_path__ + "img/playstore-2-x-8.f653ad21.png";